module.exports = __webpack_public_path__ + "static/media/detectionTask.07728cae.png";